// @flow
import { createReducer } from 'actions';
import { LOGIN, TOKEN_LOGIN, LOGOUT, FIREBASE_LOGIN } from 'actions/auth';
import type { LoginAction, TokenLoginAction, User } from 'actions/auth';

type State = {
  firebaseUser: ?Object,
  user: ?User,
  isAuthenticated: boolean,
  errorCode: ?string,
};

const initialState: State = {
  firebaseUser: null,
  user: null,
  isAuthenticated: false,
  errorCode: null,
};

export default createReducer(initialState, {
  [LOGIN]: (state: State, action: LoginAction) => {
    if (action.meta.done) {
      if (action.meta.error && action.payload && action.payload.code) {
        return {
          ...state,
          isAuthenticated: false,
          errorCode: action.payload.code,
        };
      }
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        errorCode: null,
      };
    }
    return state;
  },

  [TOKEN_LOGIN]: (state: State, action: TokenLoginAction) => {
    return {
      ...state,
      user: action.payload,
      isAuthenticated: true,
    };
  },

  [FIREBASE_LOGIN]: (state: State, action) => {
    return {
      ...state,
      firebaseUser: action.payload,
    };
  },

  [LOGOUT]: () => {
    return { ...initialState };
  },
});



// WEBPACK FOOTER //
// ./src/redux/reducers/auth.js